// URL da aplicação Finia embarcada (iframe) dentro da plataforma.
//
// Resolvida por ambiente no mesmo padrão de `src/plugins/axios.js:6-10`, para
// que a virada codespace -> produção seja a troca de uma entrada deste mapa,
// sem tocar na view nem nos testes.
//
// As três entradas apontam para o mesmo host por decisão de produto: a Finia
// roda hoje só no codespace e é esse o destino desejado em todos os ambientes.
// Quando houver deploy próprio de homologação/produção, é a troca de duas
// linhas aqui.
export const FINIA_URLS = {
  dev: 'https://finia-lantunes.codespace.aawz.com.br/',
  homolog: 'https://finia-lantunes.codespace.aawz.com.br/',
  prod: 'https://finia-lantunes.codespace.aawz.com.br/',
}

// Homologação roda com NODE_ENV=production, então a flag precisa vir antes na
// decisão — mesma ordem usada pelo axios para escolher a baseURL.
const isHomolog = process.env.VUE_APP_HOMOLOG === 'true'
const isProducao = process.env.NODE_ENV === 'production' && !isHomolog

// Exportada para teste: como as três entradas do mapa são idênticas hoje,
// afirmar sobre a URL resolvida não distingue os ramos. Cobrir o resolvedor é o
// que impede uma inversão de ordem ou um nome de env errado de passar
// despercebido até o dia em que os ambientes divergirem.
export function ambienteAtual() {
  if (isProducao) return 'prod'
  return isHomolog ? 'homolog' : 'dev'
}

export const FINIA_EMBED_URL = FINIA_URLS[ambienteAtual()]

// Emissão do ticket de uso único (SSO AAWZ -> Finia). Rota própria do
// blueprint `aawz_finia` no backend — NÃO fica sob `/api/v1/...` como o resto
// da plataforma. Ver plano_sso_aawz_finia.md §6.1/§7.3.
export const FINIA_SSO_TICKET_ENDPOINT = '/sso/finia/ticket'

// Origem confiável usada pelo listener de `postMessage` (D10, re-SSO
// silencioso) sempre que a `view` está SEM `srcAtual` para derivar a origem
// real: antes do primeiro ticket chegar e também durante cada recarga (retry
// e re-SSO), porque `executarCarregamento` zera a URL antes de pedir o ticket
// novo. Com `srcAtual` no ar, a `view` (`origemConfiavel`, em view-finia.vue)
// valida contra o destino REAL do iframe, montado pelo backend a partir de
// `FINIA_BASE_URL` (aawz_finia/core/finia_config.py) — que pode divergir deste
// mapa hardcoded do front se um dia houver deploy próprio de Finia por
// ambiente.
export const FINIA_TRUSTED_ORIGIN = FINIA_EMBED_URL
  ? new URL(FINIA_EMBED_URL).origin
  : ''
